"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayBoxHtmlNew = void 0;
require("./indexGrid.scss");
var im = require("./image-defaults/imageNone.jpg");
var DisplayBoxHtmlNew = /** @class */ (function () {
    function DisplayBoxHtmlNew() {
    }
    // Méthode optimisée pour créer un encadré, avec ou sans image, et afficher les propriétés
    DisplayBoxHtmlNew.prototype.createResultBox = function (resultBox, translations, withImage) {
        if (withImage === void 0) { withImage = false; }
        var resultBoxElement = document.createElement("div");
        if (!withImage) {
            resultBoxElement.className = "result-box-wo-i";
        }
        else {
            resultBoxElement.className = "result-box";
        }
        // Un div qui contient le type de document et éventuellement l'image
        var containerType = document.createElement("div");
        containerType.className = withImage
            ? "container-image-type"
            : "key-wo-image";
        // Création du label de type de document
        var documentTypeContainer = document.createElement("div");
        documentTypeContainer.className = withImage
            ? "document-type-container"
            : "document-type-container-wo-image";
        var documentTypeLabel = document.createElement("div");
        documentTypeLabel.className = withImage
            ? "document-type-label"
            : "document-type-label-wo-image";
        // Construire le HTML de l'icône
        var iconHtml = resultBox.typeResultBox.icon
            ? resultBox.typeResultBox.icon.startsWith("<")
                ? resultBox.typeResultBox.icon
                : "<i style=\"font-size:180%\" class=\"".concat(resultBox.typeResultBox.icon, "\"></i>")
            : "<strong>".concat(resultBox.typeResultBox.label, "</strong>");
        if (withImage) {
            documentTypeLabel.innerHTML = "<span class=\"icon-i\">".concat(iconHtml, "</span> <strong>").concat(resultBox.typeResultBox.label, "</strong>");
        }
        else {
            documentTypeLabel.innerHTML = "<strong>".concat(iconHtml, "</strong>");
        }
        documentTypeContainer.appendChild(documentTypeLabel);
        containerType.appendChild(documentTypeContainer);
        // Si avec image, ajouter l'image et le bouton "Consulter"
        if (withImage) {
            var imageContainer = document.createElement("div");
            imageContainer.className = "image-container";
            var photoElement = document.createElement("img");
            photoElement.src = resultBox.image || im;
            photoElement.alt = "Image indisponible";
            photoElement.onerror = function () {
                this.onerror = null;
                this.src = im;
            };
            imageContainer.appendChild(photoElement);
            // Ajouter le bouton "Consulter" ici
            var consultButtonContainer = document.createElement("div");
            consultButtonContainer.className = "consult-button-container";
            var consultButton = document.createElement("button");
            consultButton.textContent = "".concat(translations["Consult"]);
            consultButton.addEventListener("click", function () {
                window.open(resultBox.uri, "_blank");
            });
            consultButtonContainer.appendChild(consultButton);
            imageContainer.appendChild(consultButtonContainer);
            containerType.appendChild(imageContainer);
        }
        // Ajouter le conteneur de type (et image si nécessaire) à l'encadré principal
        resultBoxElement.appendChild(containerType);
        // Div pour le titre
        var titleElement = document.createElement("div");
        titleElement.className = withImage ? "main-title" : "main-title-wo-image";
        if (!withImage) {
            titleElement.innerHTML = "<a href=\"".concat(resultBox.uri, "\" target=\"_blank\"><strong>").concat(this.limitTitleLength(resultBox.title, 50), "</strong></a>");
        }
        else {
            titleElement.innerHTML = "<strong>".concat(this.limitTitleLength(resultBox.title, 50), "</strong>");
        }
        var Key = document.createElement("div");
        Key.className = "key";
        //si l'encadres n'a pas d'image on fait ca
        if (!withImage) {
            documentTypeContainer.appendChild(titleElement);
            containerType.appendChild(documentTypeContainer);
            //resultBoxElement.appendChild(titleElement);
        }
        else {
            Key.appendChild(titleElement);
            resultBoxElement.appendChild(Key);
        }
        // Div pour les propriétés (scrollable)
        var scrollableContainer = document.createElement("div");
        scrollableContainer.className = withImage
            ? "scrollable-container"
            : "scrollable-container-wo-image";
        this.addPropertiesToContainer(resultBox, scrollableContainer, translations);
        if (!withImage) {
            resultBoxElement.appendChild(scrollableContainer);
        }
        else {
            Key.appendChild(scrollableContainer);
            resultBoxElement.appendChild(Key);
        }
        return resultBoxElement;
    };
    // Méthode pour ajouter les propriétés à un conteneur avec la logique modifiée (récursive)
    DisplayBoxHtmlNew.prototype.addPropertiesToContainer = function (resultBox, container, translations) {
        var _this = this;
        resultBox.predicates.forEach(function (property) {
            var keyValueElementCreated = false;
            // Pour chaque valeur, on applique la logique de traitement
            property.values.forEach(function (value) {
                var keyValueElement = document.createElement("div");
                keyValueElement.className = "key-value-element";
                // Si la valeur a un label et des enfants (prédicats)
                if (value.label !== "") {
                    if (value.predicates.length > 0) {
                        if (value.label !== resultBox.title) {
                            if (value.uri !== "") {
                                keyValueElement.innerHTML = "<li>".concat(property.label, " : <a href=\"").concat(value.uri, "\" target=\"_blank\" class=\"popup-link\" data-uri=\"").concat(value.uri, "\"><strong>").concat(value.label, "</strong></a> <span class=\"objet\">(").concat(property.valueType.label, ")</span></li>");
                            }
                            else {
                                keyValueElement.innerHTML = "<li>".concat(property.label, " : ").concat(_this.limitLength(value.label, 150, translations), "</li>");
                            }
                        }
                        else {
                            keyValueElement.innerHTML = "<li>".concat(property.label, " <span class=\"objet\">(").concat(property.valueType.label, ")</span></li>");
                        }
                        // Ajouter les enfants récursivement
                        var childContainer = document.createElement("div");
                        childContainer.className = "child-container";
                        _this.addPropertiesToContainer({ predicates: value.predicates }, childContainer, translations);
                        keyValueElement.appendChild(childContainer);
                        keyValueElementCreated = true;
                    }
                }
                else if (value.label === "" && value.predicates.length > 0) {
                    // Si le label est vide mais qu'il y a des prédicats
                    //et si les children ont des valeurs on les affiche sinon on affiche juste le label
                    if (value.predicates.find(function (v) { return v.values.length > 0; })) {
                        keyValueElement.innerHTML = "<li>".concat(property.label, " :</li>");
                    }
                    // Ajouter les enfants récursivement
                    var childContainer = document.createElement("div");
                    childContainer.className = "child-container";
                    _this.addPropertiesToContainer({ predicates: value.predicates }, childContainer, translations);
                    keyValueElement.appendChild(childContainer);
                    keyValueElementCreated = true;
                }
                // Ajouter l'élément si une valeur a été traitée
                if (keyValueElementCreated) {
                    container.appendChild(keyValueElement);
                }
            });
            // Si aucun élément clé-valeur n'a été créé et que des valeurs existent, afficher une liste
            if (!keyValueElementCreated && property.values.length > 0) {
                var valuesList = property.values
                    .map(function (value) {
                    if (value.uri && value.label) {
                        return "<a href=\"".concat(value.uri, "\" target=\"_blank\" class=\"popup-link\" data-uri=\"").concat(value.uri, "\"><strong>").concat(value.label, "</strong></a>");
                    }
                    else {
                        return "".concat(_this.limitLength(value.label || "", 150, translations));
                    }
                })
                    .join("<strong> ;</strong> ");
                // ajouter une condition pour afficher le property.valueType.label que pour les valeurs qui ont un uri et un label
                //sinon on affiche juste `<li>${property.label} : ${valuesList}</li>`
                if (valuesList) {
                    if (property.values.find(function (v) { return v.uri !== "" && v.label !== ""; })) {
                        var keyValueElement = document.createElement("div");
                        keyValueElement.className = "key-value-element";
                        //console.log("Yo", valuesList);
                        keyValueElement.innerHTML = "<li>".concat(property.label, " : ").concat(valuesList, " <span class=\"objet\">(").concat(property.valueType.label, ")</span></li>");
                        container.appendChild(keyValueElement);
                    }
                    else {
                        var keyValueElement = document.createElement("div");
                        keyValueElement.className = "key-value-element";
                        keyValueElement.innerHTML = "<li>".concat(property.label, " : ").concat(valuesList, "</li>");
                        container.appendChild(keyValueElement);
                    }
                }
            }
        });
    };
    // Méthode publique pour afficher les encadrés, en utilisant createResultBox
    DisplayBoxHtmlNew.prototype.displayResultBoxes = function (startIndex, resultBoxes, resultsEl, translations) {
        if (startIndex === void 0) { startIndex = 0; }
        if (startIndex === 0) {
            resultsEl.innerHTML = "";
            var resultCount = document.createElement("div");
            resultCount.className = "result-count";
            resultCount.textContent = "".concat(resultBoxes.length, " ").concat(translations["ObjectsInResult"]);
            resultsEl.appendChild(resultCount);
        }
        var pageSize = 100;
        var endIndex = Math.min(startIndex + pageSize, resultBoxes.length);
        var gridContainer = document.createElement("div");
        //si l'image est presente on affiche le grid-container sinon on affiche le grid-container sans image
        for (var i = 0; i < resultBoxes.length; i++) {
            if (resultBoxes[i].image) {
                console.log("image");
                gridContainer.className = "result-grid";
            }
            else {
                console.log("pas d'image");
                gridContainer.className = "result-grid-wo-i";
            }
        }
        for (var i = startIndex; i < endIndex; i++) {
            var resultBox = resultBoxes[i];
            var withImage = Boolean(resultBox.image);
            var boxElement = this.createResultBox(resultBox, translations, withImage);
            gridContainer.appendChild(boxElement);
        }
        if (startIndex !== 0) {
            var separator = document.createElement("hr");
            separator.className = "result-separator";
            resultsEl.appendChild(separator);
        }
        resultsEl.appendChild(gridContainer);
        if (endIndex < resultBoxes.length) {
            this.addLoadMoreButton(endIndex, resultBoxes, resultsEl, translations);
        }
        else {
            var endMessage = document.createElement("div");
            endMessage.textContent = translations["EndResults"];
            endMessage.classList.add("end-message");
            var returnToTopButton = document.createElement("button");
            returnToTopButton.textContent = translations["BackToTop"];
            returnToTopButton.classList.add("return-to-top-button");
            returnToTopButton.addEventListener("click", function () { return window.scrollTo(0, 0); });
            resultsEl.appendChild(endMessage);
            resultsEl.appendChild(returnToTopButton);
        }
        this.initializeClickEvents();
    };
    //cette methode permet de limiter la longueur du titre de l'encadré
    //si le titre est superieur à 50 caractères, on affiche les 50 premiers caractères
    //avec l'option de popup pour afficher le titre complet si on passe la souris sur le titre
    DisplayBoxHtmlNew.prototype.limitTitleLength = function (title, maxLength) {
        if ((title !== null && title !== void 0 ? title : "").length > maxLength) {
            var truncatedTitle = (title !== null && title !== void 0 ? title : "").slice(0, maxLength) + "(...)";
            var truncatedElement = "<span class=\"truncated-title\" title=\"".concat(title, "\" style=\"color:black;\">").concat(truncatedTitle, "</span>");
            return truncatedElement;
        }
        return title !== null && title !== void 0 ? title : "";
    };
    // cette methode permet de limiter la longueur du texte
    // si on clique sur "lire la suite", on affiche le texte complet
    //cette methode permet de laisser l'encadré lisible et de ne pas surcharger l'interface
    DisplayBoxHtmlNew.prototype.limitLength = function (text, maxLength, translations) {
        if ((text !== null && text !== void 0 ? text : "").length > maxLength) {
            var truncatedTitle = (text !== null && text !== void 0 ? text : "").slice(0, maxLength);
            var remainingTitle = (text !== null && text !== void 0 ? text : "").slice(maxLength);
            var truncatedElement = "\n            <span class=\"\" title=\"".concat(text, "\">\n                ").concat(truncatedTitle, "<a class=\"show-more\">").concat(translations["more"], "</a><span class=\"remaining-title\" style=\"display: none;\">").concat(remainingTitle, "</span>\n            </span>");
            return truncatedElement;
        }
        return "<span class=\"property-text\">".concat(text !== null && text !== void 0 ? text : "", "</span>");
    };
    //cette methode permet d'initialiser les evenements click
    //prend la class "show-more" et affiche le texte complet
    //eventListener
    DisplayBoxHtmlNew.prototype.initializeClickEvents = function () {
        var showMoreElements = document.querySelectorAll(".show-more");
        showMoreElements.forEach(function (element) {
            element.addEventListener("click", function (event) {
                var target = event.target;
                var remainingTextElement = target.nextElementSibling;
                if (remainingTextElement) {
                    remainingTextElement.style.display = "inline";
                    target.style.display = "none";
                }
            });
        });
    };
    // Methode pour ajouter le bouton load more
    DisplayBoxHtmlNew.prototype.addLoadMoreButton = function (endIndex, resultBoxes, resultsEl, translations) {
        var _this = this;
        var loadMoreButton = document.createElement("button");
        loadMoreButton.textContent = "".concat(translations["LoadMore"]);
        loadMoreButton.className = "load-more-button";
        loadMoreButton.addEventListener("click", function () {
            var startIndex = endIndex;
            _this.displayResultBoxes(startIndex, resultBoxes, resultsEl, translations);
            loadMoreButton.remove();
        });
        resultsEl.appendChild(loadMoreButton);
    };
    return DisplayBoxHtmlNew;
}());
exports.DisplayBoxHtmlNew = DisplayBoxHtmlNew;
